export const makeAppointmentListReqConfig = (slug = []) => ({
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'appointments',
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    {
      type: 'payload.query',
      queryParameter: 'offset',
      selector: 'offset',
    },
    ...slug,
  ],
});

export const makeVirtualAppointmentListReqConfig = (slug = []) => ({
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'appointments',
    'virtual_visits',
    'provider_appointments',
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    {
      type: 'payload.query',
      queryParameter: 'offset',
      selector: 'offset',
    },
    {
      type: 'payload.query',
      queryParameter: 'visit_type_code',
      selector: 'visit_type_code',
    },
    {
      type: 'payload.query',
      queryParameter: 'date',
      selector: 'date',
    },
    ...slug,
  ],
});



// WEBPACK FOOTER //
// ./src/redux/healthboard/requests/appointment-req-config.js